import * as React from 'react';
import {Button, Col, Row} from 'reactstrap';
import Panel from '../../../theme/components/Panel';
import Table from '../../../theme/components/table/Table';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import DownloadIcon from 'mdi-react/DownloadIcon';
import {localCurrency} from '../../../utils/number-utils';

interface RechazosTableProps {
    rechazos?: mirana.IUIRechazo[];
    fechaInicio?: string;
    fechaFin?: string;
    fuerzaVenta?: string;
    total: number;
    handleGenerarExcel: () => {};
}

class RechazosTable extends React.PureComponent<RechazosTableProps> {

    private get resumen() {

        return this.props.rechazos ? <Row>
            <Col md={3} lg={3}>
                <h4 className='bold-text' style={{textAlign: 'center'}}>
                    <strong>Fuerza Venta: {this.props.fuerzaVenta}</strong>
                </h4>
            </Col>
            <Col md={3} lg={3}>
                <h4 className='bold-text' style={{textAlign: 'center'}}>
                    <strong>Fecha: {this.props.fechaInicio} al {this.props.fechaFin}</strong>
                </h4>
            </Col>
            <Col md={3} lg={3}>
                <h4 className='bold-text' style={{textAlign: 'center'}}>
                    <strong>Total: S/ {localCurrency(this.props.total)}</strong>
                </h4>
            </Col>
            <Col md={2} lg={2}>
                <h4 className='bold-text' style={{textAlign: 'center'}}>
                    <strong>Rechazos: {this.props.rechazos.length}</strong>
                </h4>
            </Col>
            <Col md={1} lg={1}>
                <Button outline={true} className='icon icon--only' onClick={this.props.handleGenerarExcel}
                        disabled={this.props.rechazos.length <= 0}><DownloadIcon/></Button>
            </Col>
        </Row> : null;
    }

    private get filas() {
        const content: any[] = [];
        if (this.props.rechazos) {
            this.props.rechazos.forEach((rechazo, index) => {
                content.push((
                    <tr key={`rechazo-${index}`}>
                        <td>{rechazo.fuerzaVenta}</td>
                        <td style={{textAlign: 'center'}}>{rechazo.mesa}</td>
                        <td>{rechazo.ruta} - {rechazo.vendedor}</td>
                        <td style={{textAlign: 'center'}}>{rechazo.rutaDespacho}</td>
                        <td style={{textAlign: 'center'}}>{rechazo.numeroDocumento}</td>
                        <td style={{textAlign: 'center'}}>{rechazo.codigo}</td>
                        <td className='currency-cell'><span>S/.</span><span>{localCurrency(rechazo.monto)}</span></td>
                        <td>{rechazo.motivoAnulacion}</td>
                    </tr>));
            });
        }

        return content;
    }

    public render() {
        return (
            <Panel xs={12} md={12} divider={true} title='Resultados'>
                {this.resumen}
                {this.props.rechazos ?
                    <Table striped={true} responsive={true}>
                        <thead>
                        <tr>
                            <th>Fuerza Venta</th>
                            <th>Mesa</th>
                            <th>Vendedor</th>
                            <th>Ruta Despacho</th>
                            <th>N° Documento</th>
                            <th>Cód. Cliente</th>
                            <th>Monto</th>
                            <th>Motivo anulación</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.filas}
                        </tbody>
                    </Table> : null}
            </Panel>
        )
    }
}

export default RechazosTable;



// WEBPACK FOOTER //
// ./src/components/pages/rechazos/rechazos-table.tsx